/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListUsers200ResponseLinks
 */
export interface ListUsers200ResponseLinks {
    /**
     * 
     * @type {string}
     * @memberof ListUsers200ResponseLinks
     */
    first?: string;
    /**
     * 
     * @type {string}
     * @memberof ListUsers200ResponseLinks
     */
    last?: string;
    /**
     * 
     * @type {string}
     * @memberof ListUsers200ResponseLinks
     */
    prev?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListUsers200ResponseLinks
     */
    next?: string | null;
}

/**
 * Check if a given object implements the ListUsers200ResponseLinks interface.
 */
export function instanceOfListUsers200ResponseLinks(value: object): value is ListUsers200ResponseLinks {
    return true;
}

export function ListUsers200ResponseLinksFromJSON(json: any): ListUsers200ResponseLinks {
    return ListUsers200ResponseLinksFromJSONTyped(json, false);
}

export function ListUsers200ResponseLinksFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListUsers200ResponseLinks {
    if (json == null) {
        return json;
    }
    return {
        
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'prev': json['prev'] == null ? undefined : json['prev'],
        'next': json['next'] == null ? undefined : json['next'],
    };
}

export function ListUsers200ResponseLinksToJSON(json: any): ListUsers200ResponseLinks {
    return ListUsers200ResponseLinksToJSONTyped(json, false);
}

export function ListUsers200ResponseLinksToJSONTyped(value?: ListUsers200ResponseLinks | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first': value['first'],
        'last': value['last'],
        'prev': value['prev'],
        'next': value['next'],
    };
}

